import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, CardHeader } from '@mui/material'; 
import { ArrowForwardIosTwoTone } from '@mui/icons-material';
import { NavHashLink } from 'react-router-hash-link';

const StyledLink = styled(NavHashLink)(() => ({
  textDecoration: 'none',
  display: 'block',
  color: 'inherit',
  transition: 'color 0.2s',
  '&:hover': { color: 'teal', marginLeft: 2 },
}));

export default function QuickLinks({ containerRef, title, subheader, ...other }) {
  const handleClick = () => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Box {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ ml: 2 }}>
        <StyledLink smooth onClick={handleClick} to="/landing#home">
          <ArrowForwardIosTwoTone sx={{ fontSize: 10 }} /> መነሻ ገጽ
        </StyledLink>{' '}
        <StyledLink smooth onClick={handleClick} to="/districtList">
          <ArrowForwardIosTwoTone sx={{ fontSize: 10 }} /> የአውራጃ ዝርዝር
        </StyledLink>{' '}
        <StyledLink smooth onClick={handleClick} to="/churchList">
          <ArrowForwardIosTwoTone sx={{ fontSize: 10 }} /> የቤተ ክርስቲያን ዝርዝር
        </StyledLink>
        <StyledLink smooth onClick={handleClick} to="/landing#aboutUs">
          <ArrowForwardIosTwoTone sx={{ fontSize: 10 }} /> ስለ እኛ
        </StyledLink>
        <StyledLink smooth onClick={handleClick} to="/landing#contactUs">
          <ArrowForwardIosTwoTone sx={{ fontSize: 10 }} /> ያግኙን
        </StyledLink>
      </Box>
    </Box>
  );
}

QuickLinks.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  containerRef: PropTypes.object,
};
